<template>
  <TemplateLayout
    :navigation="navigation"
    :empty="empty"
    :row-gap="rowGap"
    :content-mobile-gutters="contentMobileGutters"
    :banner-sticky-on-mobile="bannerStickyOnMobile"
    :types="types"
  >
    <template #effect></template>
    <template #main>
      <slot />
    </template>
    <template #banner>
      <div id="banner-bottom"></div>
    </template>
  </TemplateLayout>
</template>
<script setup lang="ts">
interface Props {
  types?: string[];
  navigation?: boolean;
  empty?: boolean;
  rowGap?: boolean;
  contentMobileGutters?: boolean;
  bannerStickyOnMobile?: boolean;
}
defineProps({
  types: { default: () => ['default'] },
  navigation: { type: Boolean, default: true },
  empty: { type: Boolean, default: false },
  rowGap: { type: Boolean, default: true },
  contentMobileGutters: { type: Boolean, default: true },
  bannerStickyOnMobile: { type: Boolean, default: false }
});
</script>
